import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const ContactContainer = styled(motion.div)`
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
`;

const ContactInfo = styled.div`
  background: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-bottom: 2rem;
`;

const MapContainer = styled.div`
  width: 100%;
  height: 400px;
  border-radius: 8px;
  overflow: hidden;
  margin-top: 2rem;
`;

const Contact = () => {
  return (
    <ContactContainer
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <h1>오시는 길</h1>
      <ContactInfo>
        <h2>연락처</h2>
        <p>전화: 02-1234-5678</p>
        <p>주소: 서울특별시 강남구 테헤란로 123</p>
        <p>이메일: info@seouldental.com</p>
      </ContactInfo>
      <MapContainer>
        <img src="/images/map.jpg" alt="병원 위치" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
      </MapContainer>
    </ContactContainer>
  );
};

export default Contact; 